import { VENDORS, VendorConfig } from 'configuration/config';

/**
 * Derives vendor label from a SKU string by matching the prefix against VENDORS config.
 * Returns 'Other' if no match found.
 */
export function deriveVendorFromSku(sku: string): string {
    if (!sku) return 'Other';
    const upper = sku.toUpperCase();
    const match = VENDORS.find(v => upper.startsWith(`${v.skuPrefix.toUpperCase()}-`));
    return match ? match.label : 'Other';
}

/**
 * Returns vendors that handle external/reseller orders (SHI, CDW).
 * Used for bulk order creation, reseller reports, and PO configuration.
 */
export function getBulkVendors(): VendorConfig[] {
    return VENDORS.filter(v => v.isBulkVendor);
}
